import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/shared/api.service';
import Swal from 'sweetalert2';

interface Partnership {
    id: string;
    name: string;
    email: string | null;
    phone: string | null;
    company: string | null;
    status: string;
    created_at: string;
    [key: string]: any;
}

interface Pagination {
    current_page: number;
    per_page: number;
    total: number;
    last_page: number;
}

@Component({
    selector: 'app-category',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './partnership.component.html',
    styleUrl: './partnership.component.scss'
})
export class PartnershipComponent implements OnInit {
    partnerships: Partnership[] = [];
    pagination: Pagination = {
        current_page: 1,
        per_page: 100,
        total: 0,
        last_page: 1
    };

    constructor(private apiService: ApiService) {}

    ngOnInit(): void {
        this.getPartnerships();
    }

    // ==================== FETCH DATA ====================

    async getPartnerships(): Promise<void> {
        try {
            const response = await this.apiService.get(
                `/api/v1/tenant/manage/partnership/list?page=${this.pagination.current_page}&per_page=${this.pagination.per_page}`
            );
            this.partnerships = response.data.list;
            console.log(this.partnerships);
            this.pagination = response.data.pagination;
        } catch (error: any) {
            await Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error?.error?.message || 'Terjadi kesalahan saat memuat data partnership',
                confirmButtonColor: '#dc3545',
                timer: 2000,
                showConfirmButton: false,
            });
        }
    }

    // ==================== PAGINATION ====================

    async goToPage(page: number): Promise<void> {
        if (page < 1 || page > this.pagination.last_page) {
            return;
        }
        this.pagination.current_page = page;
        await this.getPartnerships();
    }

    async nextPage(): Promise<void> {
        await this.goToPage(this.pagination.current_page + 1);
    }

    async previousPage(): Promise<void> {
        await this.goToPage(this.pagination.current_page - 1);
    }
}
